import { render, staticRenderFns } from "./CeremonyHighlights.vue?vue&type=template&id=4b4525cf&scoped=true"
import script from "./CeremonyHighlights.vue?vue&type=script&lang=js"
export * from "./CeremonyHighlights.vue?vue&type=script&lang=js"
import style0 from "./CeremonyHighlights.vue?vue&type=style&index=0&id=4b4525cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4525cf",
  null
  
)

export default component.exports